/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NutritionOrder from './nutrition-order';
import NutritionOrderDetail from './nutrition-order-detail';
import NutritionOrderUpdate from './nutrition-order-update';
import NutritionOrderDeleteDialog from './nutrition-order-delete-dialog';

const NutritionOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NutritionOrder />} />
    <Route path="new" element={<NutritionOrderUpdate />} />
    <Route path=":id">
      <Route index element={<NutritionOrderDetail />} />
      <Route path="edit" element={<NutritionOrderUpdate />} />
      <Route path="delete" element={<NutritionOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NutritionOrderRoutes;
